module.exports = __webpack_public_path__ + "img/li.8d03a57d.svg";